import APIConfiguration from '@savgroup-front-common/configuration/src/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/src/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/closed`;

export interface ForceCloseFileCommandPayload {
  fileId: string;
  comment?: string;
  toCustomerComment?: string;
}

async function forceCloseFileCommand({
  fileId,
  comment,
  toCustomerComment,
}: ForceCloseFileCommandPayload): Promise<BaseBackResponse> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        comment,
        toCustomerComment,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default forceCloseFileCommand;
